<template>
  <!-- si no tenemos un pokemon -->
  <h1 v-if="!pokemon">Espere por favor...</h1>
  <!-- si tenemos un pokemon -->
  <div v-else>
    <h1>¿Quién es este pokémon?</h1>
    <!-- : es igual a hacer v-bind -->
    <!-- Los atributos los podemos definir como show-pokemon en lugar de showPokemon -->
    <pokemonPicture :pokemonId="pokemon.id" :show-pokemon="showPokemon" />
    <pokemonOptions :pokemons="pokemonArr" @selection="checkAnswer" />

    <div v-if="showAnswer">
      <h2 class="fade-in">{{ message }}</h2>
      <button class="buttonNew" @click="newGame">Nuevo Juego</button>
    </div>
  </div>
</template>

<script>
import pokemonPicture from "@/components/PokemonPicture.vue";
import pokemonOptions from "@/components/PokemonOptions.vue";
import getPokemonOptions from "@/helpers/getPokemonOptions";

// console.log(getPokemonOptions());

export default {
  components: {
    pokemonPicture,
    pokemonOptions,
  },
  data() {
    // son Getter/Setter que son propiedades reactivas
    return {
      pokemonArr: [],
      pokemon: null,
      showPokemon: false,
      showAnswer: false,
      message: "",
    };
  },
  methods: {
    async mixPokemonArray() {
      //Te trae todo el arreglo de los pokemons 650 de lo cuales eligiremos entre 4
      this.pokemonArr = await getPokemonOptions();
      //Generamos un numero random para la posicion entre 0 y 3
      const rndInt = Math.floor(Math.random() * 4);

      this.pokemon = this.pokemonArr[rndInt];
      console.log("que tiene this.pokemonArr", this.pokemonArr);
      console.log("que tiene this.pokemon", this.pokemon);
      console.log("que tiene this.pokemon.id", this.pokemon.id);
      // console.log(this.pokemonArr);
    },
    checkAnswer(pokemonId) {
      this.showPokemon = true;
      this.showAnswer = true;

      if (pokemonId === this.pokemon.id) {
        this.message = `Correcto!, ${this.pokemon.name}`;
      } else {
        this.message = `Opps, era ${this.pokemon.name}`;
      }
    },
    newGame() {
      this.showPokemon = false;
      this.showAnswer = false;
      this.pokemonArr = [];
      this.pokemon = null;
      this.mixPokemonArray();
      // this.pokemonArr
    },
  },
  mounted() {
    this.mixPokemonArray();
  },
};
</script>
<style>
.buttonNew:hover {
  background-color: dodgerblue;
  color: white;
}
.buttonNew {
  font-size: 20px;
  padding: 9px;
  border-radius: 10px;
  cursor: pointer;
}
</style>
<!-- Sin v-bind: Pasas texto literal
Con v-bind: Pasas datos de JavaScript (números, variables, objetos, etc.) -->
